import * as Account from './account';
import * as AuthInfo from './authInfo';

export const ApiConvereter = { AuthInfo, Account };
